<div class="flex flex-col gap-8 justify-center items-center">
  <div class="flex flex-col items-center justify-end gap-2 w-[220px]">
    <mat-label class="text-2xl font-bold">{{ label }}</mat-label>
    <span
      class="h-10 w-full text-2xl text-right align-middle pr-5 pt-2 border border-solid border-gray-500 rounded-md"
      >{{ currentAmount || 0 }} Kg.</span
    >
  </div>
  <div class="flex flex-col justify-between items-center gap-5">
    <div class="flex flex-row justify-between items-center gap-5">
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('7')"
      >
        7
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('8')"
      >
        8
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('9')"
      >
        9
      </button>
    </div>
    <div class="flex flex-row justify-between items-center gap-5">
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('4')"
      >
        4
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('5')"
      >
        5
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('6')"
      >
        6
      </button>
    </div>
    <div class="flex flex-row justify-between items-center gap-5">
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('1')"
      >
        1
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('2')"
      >
        2
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('3')"
      >
        3
      </button>
    </div>
    <div class="flex flex-row justify-between items-center gap-5">
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="removeLatest()"
      >
        <mat-icon fontIcon="backspace" class="pl-3 mt-1" />
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl h-20 w-20"
        (click)="addNumber('0')"
        [disabled]="this.currentAmount === '0' || this.currentAmount === ''"
      >
        0
      </button>
      <button
        mat-raised-button
        class="rounded-2 text-3xl font-bold h-20 w-20"
        (click)="confirm()"
        [disabled]="this.currentAmount === '0' || this.currentAmount === ''"
      >
        OK
      </button>
    </div>
  </div>
</div>
